import React from 'react';
import { Field } from 'redux-form';
import { TableRow, makeStyles } from '@material-ui/core/';
import ClearIcon from '@material-ui/icons/Clear';
import TableComponents from 'components/Table';
import { FieldPercent } from 'components/Base';
import Fields from 'components/Fields';
import { MetaType } from 'store/modules/Meta/types';

const useStyles = makeStyles({
  deleteIcon: {
    fontSize: '1rem',
    cursor: 'pointer'
  }
});

interface AssetClassProps {
  assetClasses: Array<MetaType>;
  index: number;
  removeAsset: (inde: number) => void;
  field: string;
}

const AssetClass = ({
  assetClasses,
  index,
  removeAsset,
  field
}: AssetClassProps) => {
  const classes = useStyles();
  return (
    <TableRow>
      <TableComponents.TableCell width="100px">
        <FieldPercent
          name={`${field}.percentage_value`}
          component={Fields.Text}
          clearfieldinform="manualFund"
          validate={[
            Fields.Validators.isPercentageValid,
            Fields.Validators.required
          ]}
        />
      </TableComponents.TableCell>
      <TableComponents.TableCell>
        <Field
          fullWidth
          name={`${field}.asset_class`}
          component={Fields.Select}
          options={assetClasses}
          validate={Fields.Validators.required}
        />
      </TableComponents.TableCell>
      <TableComponents.TableCell width="25px">
        <ClearIcon
          onClick={() => removeAsset(index)}
          className={classes.deleteIcon}
        />
      </TableComponents.TableCell>
    </TableRow>
  );
};

export default AssetClass;
